'use client'

import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { akustikPanellerFaqs } from '@/data/catalog'

export default function AkustikPanellerFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  return (
    <section className="akustik-paneller-faq py-10 md:py-14 bg-[#f5f5f5]">
      <div className="container mx-auto px-4 max-w-6xl">
        <div className="text-center mb-7">
          <div className="text-[#b45309] font-semibold text-[11px] md:text-xs uppercase tracking-wider mb-1">
            SSS
          </div>
          <h2
            className="text-2xl md:text-3xl font-bold"
            style={{
              background: 'linear-gradient(to top right, #014b64, #01124d)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Akustik Paneller Hakkında Sıkça Sorulan Sorular
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-2">
          {akustikPanellerFaqs.map((faq, index) => {
            const open = openIndex === index
            return (
              <div
                key={faq.question}
                className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden"
              >
                <button
                  type="button"
                  className="w-full px-4 py-3.5 text-left flex justify-between items-center gap-3 hover:bg-gray-50"
                  onClick={() => setOpenIndex(open ? null : index)}
                  aria-expanded={open}
                >
                  <span className="font-semibold text-[#232f3e] text-sm md:text-[15px]">
                    {faq.question}
                  </span>
                  <ChevronDown
                    size={16}
                    className={`text-[#b45309] shrink-0 transition-transform ${
                      open ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {open ? (
                  <p className="text-[#4b5563] text-sm leading-relaxed px-4 pb-4">
                    {faq.answer}
                  </p>
                ) : null}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
